module.exports = __webpack_public_path__ + "img/a_e2.935f0c59.png";